const RemittanceVoucherDetail = () => import('Views/user/remittance-voucher-detail');

export default[
  { path: '/remittance-voucher-detail/:id', component: RemittanceVoucherDetail },
];



// WEBPACK FOOTER //
// ./src/router/remittanceVoucher.js